(() => {
  'use strict';
  const labels = /^(\s*(?:Brand|Model|Reference(?: number)?|Reference No\.?|Year|Case(?: size| material| diameter| thickness)?|Caseback|Crown|Pushers|Diameter|Size|Movement|Calib(?:er|re)|Dial(?: colo[u]r|\/Hands)?|Bezel|Crystal|Bracelet(?:\/Strap)?|Strap|Clasp(?:\/Buckle)?|Water resistance|Power reserve|Condition|Polishing Status|Box(?: and| &)? papers|Box|Papers|Included(?: items)?|Service(?: history)?|Functions|Gender|Material|Lug width|Lug-to-Lug|Serial(?: number)?)\s*:)([\s\S]+)$/iu;
  function structureSpecifications(root) {
    root.querySelectorAll('[data-watch-description],.kw-fulldesc-in').forEach(description => {
      description.querySelectorAll('p').forEach(paragraph => {
        if (paragraph.closest('table,ul,ol,dl') || paragraph.querySelector('a,img,video,iframe,input')) return;
        const parts = paragraph.innerHTML.split(/<br\s*\/?\s*>/iu);
        if (parts.length < 2) return;
        const rows = parts.map(html => {
          const holder = document.createElement('div');
          holder.innerHTML = html;
          const text = holder.textContent;
          return { text, match: text.match(labels) };
        });
        if (rows.filter(row => row.match).length < 2 || rows.some(row => row.text.trim() && !row.match)) return;
        const list = document.createElement('dl');
        list.className = 'kw-description-specs';
        for (const row of rows) {
          if (!row.match) { list.append(document.createTextNode(row.text)); continue; }
          const group = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = row.match[1];
          value.textContent = row.match[2];
          group.append(label,value);
          list.append(group);
        }
        if (list.textContent === paragraph.textContent) paragraph.replaceWith(list);
      });
      description.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.isConnected || paragraph.closest('table,ul,ol,dl') || paragraph.querySelector('a,img,video,iframe,br') || !paragraph.textContent.match(labels)) return;
        const nodes = [];
        const matches = [];
        let sibling = paragraph;
        while (sibling) {
          if (sibling.nodeType === 3 && !sibling.textContent.trim()) { nodes.push(sibling); sibling = sibling.nextSibling; continue; }
          if (sibling.nodeType !== 1 || sibling.tagName !== 'P' || sibling.querySelector('a,img,video,iframe,br')) break;
          const match = sibling.textContent.match(labels);
          if (!match) break;
          matches.push(match); nodes.push(sibling); sibling = sibling.nextSibling;
        }
        if (matches.length < 2) return;
        const original = nodes.map(node => node.textContent).join('');
        const list = document.createElement('dl');
        list.className = 'kw-description-specs';
        for (const node of nodes) {
          if (node.nodeType === 3) { list.append(document.createTextNode(node.textContent)); continue; }
          const match = node.textContent.match(labels);
          const group = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = match[1]; value.textContent = match[2];
          group.append(label,value); list.append(group);
        }
        if (list.textContent !== original) return;
        paragraph.before(list);
        nodes.forEach(node => node.remove());
      });
    });
  }
  function initialize(root = document) {
    const board = document.getElementById('b-4a');
    window.KingdomDescription?.initialize(root);
    root.querySelectorAll('.kw-hdr').forEach(header => {
      const menu = header.querySelector('.kw-mobile-nav');
      const toggle = header.querySelector('.kw-menu-toggle');
      if (!menu || !toggle || menu.dataset.revisionBound) return;
      menu.dataset.revisionBound = 'true';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'kw-menu-close';
      close.textContent = '× ' + board.dataset.closeLabel;
      close.addEventListener('click', () => {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded','false');
        toggle.focus();
      });
      menu.prepend(close);
      new MutationObserver(() => {
        toggle.textContent = menu.hidden ? board.dataset.menuLabel : '× ' + board.dataset.closeLabel;
      }).observe(menu,{attributes:true,attributeFilter:['hidden']});
    });
    structureSpecifications(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
